package com.milta.core.localization.translations.ro

import com.milta.core.localization.TeamStrings

internal val Team = TeamStrings(
    screenTitle = "Echipă",
    statusActive = "Activ",
    errorGeneric = "A apărut o eroare. Încercați din nou.",
    monthNames = listOf("ianuarie", "februarie", "martie", "aprilie", "mai", "iunie", "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie"),
    enterpriseSectionLabel = "Șoferii echipei",
    enterpriseEmptyHint = "Nu aveți încă niciun șofer în echipă.",
    noEnterpriseFound = "Nicio companie asociată contului dvs.",
    columnHeaderDriver = "Șofer",
    columnHeaderStatus = "Stare",
    columnHeaderActions = "Acțiuni",
    addDriverSectionTitle = "Adăugați un șofer",
    addDriverCodePlaceholder = "Cod Milta — ex: MTA-28371",
    addDriverButton = "Adăugați acest șofer",
    addDriverErrorInvalidCode = "Vă rugăm să introduceți un cod valid.",
    addDriverErrorNotFound = "Cod invalid sau deja utilizat.",
    addDriverErrorAlreadyMember = "Acest șofer face deja parte din echipa dvs.",
    addDriverErrorLinkedAccountIsEnterprise = "Acest cont este o companie și nu poate fi adăugat ca șofer.",
    addDriverErrorLimitReached = "Limită atinsă: o companie nu poate avea mai mult de 10 membri, inclusiv dumneavoastră. Eliminați un șofer pentru a adăuga altul.",
    addDriverErrorEnterpriseSubscriptionInactive = "Abonamentul Companiei dumneavoastră a expirat: reînnoiți-l pentru a adăuga un șofer.",
    driverDetailTitle = "Detalii șofer",
    driverDetailPhoneLabel = "Telefon",
    removeDriverButton = "Elimină",
    removeDriverDialogTitle = "Eliminați acest șofer?",
    removeDriverDialogMessagePrefix = "Sunteți pe cale să eliminați",
    removeDriverDialogMessageSuffix = "din echipa dvs. Contul său Milta va rămâne activ.",
    removeDriverErrorNotFound = "Șofer negăsit.",
    removeDriverErrorOnActiveDelivery = "Acest șofer este în prezent într-o livrare activă și nu poate fi eliminat.",
    removeDriverErrorLastOwner = "Sunteți singurul administrator al acestei companii. Adăugați un alt cont de Companie înainte de a vă retrage din echipă.",
)
